import Filter from '@/src/components/organism/Filter';
import { useEffect, useRef, useState } from 'react';
import { inquiryFilters } from './filter';
import { useQuery } from '@tanstack/react-query';
import useQueryValues from '@/src/hooks/useQueryValues';
import MainContentTitle from '@/src/components/molecule/MainContentTitle';
import { AgGridReact } from 'ag-grid-react';
import Table from '@/src/components/atom/Table';
import { inquiryListColumn } from './column';
import SectionCardNoneTitle from '@/src/components/molecule/SectionCardNoneTitle';
import Typo from '@/src/components/atom/Typo';
import usePaginationQuery from '@/src/hooks/usePaginationQuery';
import { NAV_CONST } from '@/src/constants/nav';
import {
  getInquiriesAPI,
  getInquiryCategoriesAPI,
} from '@/src/apis/rest/inquiry';
import { useNavigate } from 'react-router-dom';
import PATH from '@/src/routes/path';

export default function InquiryListPage() {
  const navigate = useNavigate();

  const { defaultValues } = useQueryValues({
    createdAt: ['createdAtFrom', 'createdAtTo'],
  });
  const { page, pageSize, handlePageChange } = usePaginationQuery();

  const gridRef = useRef<AgGridReact>(null);
  const [values, setValues] = useState(defaultValues);

  const { data: inquiryCategories } = useQuery({
    queryKey: ['inquiry-category'],
    queryFn: getInquiryCategoriesAPI,
  });
  const {
    data: InquiryListOrigin,
    isError,
    isFetching,
  } = useQuery({
    queryKey: ['Inquirys', values, page, pageSize],
    queryFn: () => {
      return getInquiriesAPI({
        ...values,
        page,
        pageSize,
      });
    },
  });

  useEffect(() => {
    if (isFetching && gridRef.current) {
      gridRef.current.api?.showLoadingOverlay();
    }
  }, [isFetching]);

  return (
    <>
      <MainContentTitle
        pageTitle={NAV_CONST.inquiryManagement}
        breadcrumbList={[NAV_CONST.inquiry]}
      />
      <div className="mb-20 flex flex-col gap-6">
        <Filter
          title="검색 필터"
          filters={inquiryFilters(
            (inquiryCategories || []).map(item => ({
              label: item,
              value: item,
            })),
          )}
          onSubmit={values => {
            handlePageChange(1, pageSize, false);
            setValues(values);
          }}
        />
        <div className="flex flex-col gap-y-6">
          <SectionCardNoneTitle
            contentProps={{
              className: 'flex flex-col gap-y-4',
            }}
          >
            <div className="flex items-center justify-between">
              <Typo typoType="b18m">1:1 문의 목록</Typo>
            </div>

            <Table
              ref={gridRef}
              rowData={isError ? [] : InquiryListOrigin?.rows || []}
              isPaginationDataMapping
              columnDefs={inquiryListColumn(id => {
                navigate(PATH.INQUIRY_DETAIL.replace(':id', String(id)));
              })}
              total={InquiryListOrigin?.count || 0}
              page={page}
              pageSize={pageSize}
              handlePaginationClick={handlePageChange}
            />
          </SectionCardNoneTitle>
        </div>
      </div>
    </>
  );
}
